export default {"src":"/_next/static/media/change-recipes.26898d7f.svg","height":71,"width":70,"blurWidth":0,"blurHeight":0};